import { Schema as S } from "effect";
import { defineApi } from "../client";
import { Page, Success } from "../schemas/common";

export const TYPES = [
	"related",
	"friend",
	"partner",
	"former_partner",
	"sibling",
	"parent",
	"child",
	"colleague",
	"manager",
	"report",
	"mentor",
	"mentee",
] as const;
export const RelationshipType = S.Literals(TYPES);
export const Relationship = S.Struct({
	id: S.String,
	personId: S.String,
	name: S.String,
	subtitle: S.NullOr(S.String),
	type: RelationshipType,
});
export type Relationship = typeof Relationship.Type;
export const getRelationships = defineApi("GetRelationships", {
	args: { nodeId: S.String, cursor: S.Number, asOf: S.NullOr(S.String) },
	response: Page(Relationship),
	request: ({ nodeId, cursor, asOf }) => ({
		method: "GET",
		path: `/records/${nodeId}/relationships`,
		query: { cursor, as_of: asOf },
	}),
});
export const writeRelationship = defineApi("WriteRelationship", {
	args: {
		nodeId: S.String,
		personId: S.String,
		type: RelationshipType,
		remove: S.Boolean,
	},
	response: Success,
	request: ({ nodeId, personId, type, remove }) => ({
		method: remove ? "DELETE" : "POST",
		path: `/records/${nodeId}/relationships`,
		body: { personId, type },
	}),
});
export const createRelationshipPerson = defineApi("CreateRelationshipPerson", {
	args: { name: S.String, timestamp: S.String },
	response: S.Struct({ created: S.String }),
	request: ({ name, timestamp }) => ({
		method: "POST",
		path: "/records",
		body: {
			name,
			type: "person",
			description: "",
			avatars: [],
			tags: [],
			attributes: {},
			timestamp,
		},
	}),
});
